export function getSessionStorageItem(key) {
  return sessionStorage.getItem(key);
}

export function setSessionStorageItem(key, value) {
  return sessionStorage.setItem(key, value);
}
